import React from "react";
import bots from "../botsData";

const TOS = () => {
  const botNames = bots.map((bot) => bot.name).join(", ");

  return (
    <div className="relative min-h-screen py-16 px-4">
      <div className="pointer-events-none absolute inset-x-0 top-6 left-1/2 h-px w-[80%] -translate-x-1/2 bg-gradient-to-r from-transparent via-apb-accent-cyan to-transparent opacity-70" />
      <div className="pointer-events-none absolute inset-x-0 top-20 left-0 h-full w-full">
        <div className="mx-auto h-full max-w-6xl bg-[linear-gradient(to_right,transparent_0%,rgba(255,255,255,0.06)_2px,transparent_2px,transparent_52px),linear-gradient(to_bottom,transparent_0%,rgba(255,255,255,0.06)_2px,transparent_2px,transparent_52px)] bg-[length:52px_52px,52px_52px] opacity-10" />
      </div>
      <main className="flex-grow relative z-10">
        <article className="max-w-5xl mx-auto apb-surface-glass p-8 sm:p-10 rounded-2xl mb-16 mt-2 border border-apb-border-soft">
          <div className="inline-flex items-center gap-2 rounded-full border border-apb-border-soft bg-black/20 px-4 py-1.5 text-xs uppercase tracking-[0.25em] text-apb-text-secondary">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-apb-accent-purple apb-glow-purple" />
            Legal
          </div>
          <h1 className="text-4xl font-extrabold mt-5 mb-2 apb-glow-text">
            Terms of Service for Afterparty Bots
          </h1>
          <p className="text-apb-text-secondary mb-6">Last Updated: January 20, 2026</p>

          <p className="text-lg text-apb-text-secondary mb-5">
            By using the Bots ({botNames}), you agree to these Terms of Service. Please read them carefully.
          </p>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">1. Use of the Bots</h2>
            <p className="text-apb-text-secondary mt-3">
              The Bots are designed to operate within the Discord platform and must be used in compliance with Discord&apos;s{" "}
              <a
                href="https://discord.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-apb-accent-cyan underline underline-offset-4"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://discord.com/guidelines"
                target="_blank"
                rel="noopener noreferrer"
                className="text-apb-accent-cyan underline underline-offset-4"
              >
                Community Guidelines
              </a>
              .
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">2. User Conduct</h2>
            <ul className="list-disc list-inside mt-3 space-y-2 text-apb-text-secondary">
              <li>Do not abuse, spam, or misuse the Bots.</li>
              <li>Do not use the Bots for illegal, harmful, or malicious purposes.</li>
              <li>Do not exploit vulnerabilities or attempt to interfere with the Bots&apos; functionality.</li>
            </ul>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">3. Data Usage</h2>
            <p className="text-apb-text-secondary mt-3">
              By using the Bots, you consent to the collection and use of data as described in our{" "}
              <a href="/privacy" className="text-apb-accent-cyan underline underline-offset-4">
                Privacy Policy
              </a>
              .
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">4. Changes and Availability</h2>
            <p className="text-apb-text-secondary mt-3">
              We reserve the right to modify the Bots&apos; features or discontinue them at any time without prior notice.
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">5. Termination of Use</h2>
            <p className="text-apb-text-secondary mt-3">
              We may suspend or terminate your access to the Bots at any time, with or without cause, including violations of these Terms or Discord&apos;s policies.
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">6. Disclaimer of Warranty</h2>
            <p className="text-apb-text-secondary mt-3">
              The Bots are provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service.
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">7. Limitation of Liability</h2>
            <p className="text-apb-text-secondary mt-3">
              We are not liable for any damages resulting from the use or inability to use the Bots, including data loss, service disruption, or account issues.
            </p>
          </section>

          <section className="mt-7 rounded-xl border border-apb-border-soft bg-apb-bg-card/55 p-5">
            <h2 className="text-2xl font-bold text-white apb-glow-text">8. Contact Us</h2>
            <p className="text-apb-text-secondary mt-3">
              For questions or issues related to these Terms of Service, contact us at{" "}
              <a
                href="mailto:support@afterpartylabs.xyz"
                className="text-apb-accent-cyan underline underline-offset-4"
              >
                support@afterpartylabs.xyz
              </a>
              .
            </p>
          </section>
        </article>
      </main>
    </div>
  );
};

export default TOS;
